// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormResetPassword_wrapper__1FW_O","form":"FormResetPassword_form__Vyytg","actions":"FormResetPassword_actions__F2iiL"};